import { Observable } from 'rxjs';

export interface PollingConfiguration {
  /**
   * A function to be called before polling starts.
   */
  initialize?: () => Observable<unknown>;

  /**
   * The function to be called for polling.
   * The returned Observable must emit `true` to stop polling.
   */
  poll: (timeout: number) => Observable<boolean>;

  /**
   * A function to be called when polling succeeds,
   * but before success is indicated to the user.
   */
  complete?: () => Observable<unknown>;

  /**
   * A function to be called once polling success has been indicated
   * to the user for an appropriate amount of time
   */
  proceed?: () => Observable<unknown>;

  /**
   * The amount of times that calling `initialize` should be tried
   * in total (default: 3)
   */
  initializeRetryCount?: number;

  /**
   * The amount of times that calling `complete` should be tried
   * in total (default: 3)
   */
  completeRetryCount?: number;

  /**
   * The amount of times that calling `proceed` should be tried
   * in total (default: 3)
   */
  proceedRetryCount?: number;

  /**
   * The interval in ms in which `poll` is called (default: 1000)
   */
  pollingInterval?: number;

  /**
   * The duration in ms for which the current window is visible
   * between the end of `complete` and the beginning of `proceed`
   * (default: 1000)
   */
  waitingDuration?: number;
}
